import { Modal } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import _ from 'lodash';
import { Provider } from 'react-redux';
import styled from 'styled-components';
import { IAddedQuestion, ISurveyQuestionEditModel } from '../../models';
import { DemographicQuestionModalContent } from './demographic-questions/DemographicQuestionModalContent';
import { QuestionModalContent } from './QuestionModalContent';

const QuestionModalContentWrapper = styled.div`
	width: 100%;
`;

export interface IQuestionModalProps {
	addedQuestions: IAddedQuestion[];
	disableClose: boolean;
	isDemographic: boolean;
	isLoading: boolean;
	isOpen: boolean;
	parentQuestion?: ISurveyQuestionEditModel;
	primaryButtonText?: string;
	secondaryButtonText?: string;
	selectedCustomQuestionIds: number[];
	selectedQuestionVariationIds: number[];
	store: any;
	surveyId: number;
	title: string;
	SubmitQuestionsModal: (
		addedQuestions: IAddedQuestion[],
		selectedQuestionVariationIds: number[],
		selectedCustomQuestionIds: number[],
		isDemographic: boolean,
	) => void;
}

export class QuestionsModal extends React.PureComponent<IQuestionModalProps> {
	constructor(props: IQuestionModalProps) {
		super(props);

		this.finishAndCloseModal = this.finishAndCloseModal.bind(this);
	}

	public render() {
		return (
			<Modal
				isOpen={this.props.isOpen}
				title={this.props.title}
				onSubmit={this.props.primaryButtonText !== undefined ? this.finishAndCloseModal : undefined}
				onClosed={this.finishAndCloseModal}
				secondaryButtonText={this.props.secondaryButtonText}
				contentfullwidth={true}
				contenthcentered={true}
				primaryButtonText={this.props.primaryButtonText}
				secondaryButtonDisabled={this.props.disableClose}
				primaryButtonDisabled={this.props.disableClose}
			>
				<QuestionModalContentWrapper>
					<Provider store={this.props.store}>
						{!this.props.isDemographic && (
							<QuestionModalContent
								isDemographic={this.props.isDemographic}
								isLoading={this.props.isLoading}
								parentQuestion={this.props.parentQuestion}
								selectedCustomQuestionIds={this.props.selectedCustomQuestionIds}
								selectedQuestionVariationIds={this.props.selectedQuestionVariationIds}
								surveyId={this.props.surveyId}
							/>
						)}
						{this.props.isDemographic && (
							<DemographicQuestionModalContent
								isLoading={this.props.isLoading}
								selectedQuestionVariationIds={this.props.selectedQuestionVariationIds}
								selectedCustomQuestionIds={this.props.selectedCustomQuestionIds}
							/>
						)}
					</Provider>
				</QuestionModalContentWrapper>
			</Modal>
		);
	}

	private finishAndCloseModal() {
		if (!this.props.disableClose) {
			const questionVariationIds = _.uniq(this.props.selectedQuestionVariationIds);
			const customQuestionIds = _.uniq(this.props.selectedCustomQuestionIds);
			this.props.SubmitQuestionsModal(this.props.addedQuestions, questionVariationIds, customQuestionIds, this.props.isDemographic);
		}
	}
}
